import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://furbabiesai-image-23945973330.us-east5.run.app',
    // baseURL: process.env.REACT_APP_API_URL,
    timeout: 100000000,
    withCredentials: true,
});

axiosInstance.interceptors.request.use(config => {
    if (config.data instanceof FormData) {
        config.headers['Content-Type'] = 'multipart/form-data';
    } else {
        config.headers['Content-Type'] = 'application/json';
    }
    const sessionId = localStorage.getItem('sessionId');
    if (sessionId) {
        config.headers['X-Session-ID'] = sessionId;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export default axiosInstance;
